import axios from "axios";
import Vue from "vue";
import {
  Loading
} from "element-ui";
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_URL, // url = base url + request url
   baseURL: " http://www.nttzzc.cn/WebService",
  //  baseURL: " http://10.86.12.52:8083/WebService",
  //baseURL: " http://10.86.12.52:8089/WebService",
   //baseURL: " http://171.12.11.106:2206/WebService",
  // baseURL: "/api",

  timeout: 35000, // request timeout
});
var loadingInstance1;
//  请求拦截器
service.interceptors.request.use(
  (config) => {
    // // console.log('config',config)
    // config.headers["Content-Type"] = "application/json;charset=UTF-8";
    // config.headers["Accept"] = "application/json";
    // config.headers['Request-From'] = 'mobile'

    let token = sessionStorage.getItem("loginToken") || null;
    if (token) {
      // 如果token不为null，否则传token给后台
      config.headers["Token"] = token;
    }
    if (config.data != null) {
      let indexofs = config.data.indexOf("Get_SpecialVisits")
      if (indexofs == -1) {
        loadingInstance1 = Loading.service({
          fullscreen: true
        });
        // // console.log(config.data,'111111111111',config.data.indexOf("Get_SpecialVisits"))
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response;
    loadingInstance1.close();
    //届时根据后端返回success或者code值判断
    if (res.status === 200) {
      return res.data;
    } else {
      return res.data;
    }
  },
  (error) => {
    loadingInstance1.close();
    //响应错误
    loadingInstance1.close();
    return Promise.reject(error);
  }
);

export {
  service as axios
};